import {View} from './view';
import {Translations} from '../config/translations';
import { StripeView } from './stripe-view';
import { PaymentType } from '../providers/payment-type';

export class StripeMobilePayView extends View {

    stripeView: StripeView = new StripeView();

    renderForm() {
        this.renderErrorContainer();
        this.renderPaymentRequestButton();
        this.renderSealsImage();
    }

    renderErrorContainer() {
        const errorContainer = document.createElement('div');
        errorContainer.setAttribute('id', 'stripe_mobile_pay_error_container');
        errorContainer.setAttribute('class', 'hs-form stacked');
        errorContainer.innerHTML =
            `<label id='stripe_mobile_pay_error' class='hs-form stacked error'></label>`;
        const widgetFooterContainer = this.getHtmlElement('#df-widget-footer');
        const widgetContainer = widgetFooterContainer.parentNode;
        if (widgetContainer) {
            widgetContainer.insertBefore(errorContainer, widgetFooterContainer.previousElementSibling);
        }
    }

    renderPaymentRequestButton() {
        const stripeMobilePayFormFragment = document.createDocumentFragment();
        const stripeMobilePayForm = document.createElement('form');
        stripeMobilePayForm.setAttribute('id', 'stripe-mobile-pay-form');
        stripeMobilePayForm.innerHTML = `${this.getPaymentRequestButtonElement()}`;
        stripeMobilePayFormFragment.appendChild(stripeMobilePayForm);

        const stripeMobilePayFormContainer = this.getHtmlElement('#stripe-mobile-pay-form-block');
        stripeMobilePayFormContainer.appendChild(stripeMobilePayForm);
    }

    getPaymentRequestButtonElement() {}

    renderSealsImage() {
        const sealsDiv = document.createElement('div');
        sealsDiv.setAttribute('id', 'stripe-mobile-pay-form-seals');
        sealsDiv.innerHTML = this.stripeView.getSealsElementHtml();
        const widgetFooterContainer = this.getHtmlElement('#df-widget-footer');
        const widgetContainer = widgetFooterContainer.parentNode;
        if (widgetContainer) {
            widgetContainer.insertBefore(sealsDiv, widgetFooterContainer.previousElementSibling);
        }
    }

    setVisible(isActive: boolean) {
        const form = this.getHtmlElement('#stripe-mobile-pay-form-block');
        if (!form) {
            return;
        }
        const errorContainer = this.getHtmlElement('#stripe_mobile_pay_error_container');
        const sealsElement = this.getHtmlElement('#stripe-mobile-pay-form-seals');
        const paymentRequestButton = this.getHtmlElement('#stripe_payment_request_button');
        if (isActive) {
            this.show(form);
            this.show(errorContainer);
            this.show(sealsElement);
            this.show(paymentRequestButton);
        } else {
            this.hide(form);
            this.hide(errorContainer);
            this.hide(sealsElement);
            this.hide(paymentRequestButton);
        }
    }

    hideForm() {
        const errorContainer = this.getHtmlElement('#stripe_mobile_pay_error_container');
        const sealsElement = this.getHtmlElement('#stripe-mobile-pay-form-seals');
        if (errorContainer && sealsElement) {
            errorContainer.style.display = 'none';
            sealsElement.style.display = 'none';
        }
    }

    showForm() {
        const errorContainer = this.getHtmlElement('#stripe_mobile_pay_error_container');
        const sealsElement = this.getHtmlElement('#stripe-mobile-pay-form-seals');
        if (errorContainer && sealsElement) {
            errorContainer.style.display = 'block';
            sealsElement.style.display = 'block';
        }
    }

    removeMobilePaymentMethodElement() {
        let paymentMethodElements = this.getPaymentMethodElements();
        const mobilePaymentMethodElement = this.findMobilePaymentMethodElement(paymentMethodElements);
        if (mobilePaymentMethodElement && mobilePaymentMethodElement.parentElement && mobilePaymentMethodElement.parentElement.parentElement) {
            mobilePaymentMethodElement.parentElement.parentElement.remove();
        }
        paymentMethodElements = this.getPaymentMethodElements();
        paymentMethodElements[0].click();
        if (paymentMethodElements.length === 1) {
            this.removeElement('df-payment-method');
        }
    }

    findMobilePaymentMethodElement(paymentMethodElements: any) {
        for (let i = 0; i < paymentMethodElements.length; i++) {
            if (paymentMethodElements[i].value === PaymentType.STRIPE_GOOGLE_PAY ||
                paymentMethodElements[i].value === PaymentType.STRIPE_APPLE_PAY) {
                    return paymentMethodElements[i];
                }
        }
        return null;
    }

    getPaymentMethodElements() {
        return this.getHtmlElements('#df-payment-method input.df-payment-type');
    }

}
